const UppercaseLabel = ({ label }) => {
    return (
        <label className="block text-lg font-bold uppercase tracking-wide text-gray-700 lg:text-xs">
            {label}
        </label>
    )
}

export default UppercaseLabel
